import React, { ReactElement } from 'react'
import Divider from '../../Divider'
import EmptyOverview from './EmptyOverview'
import { ArtData } from '@/database/art'

const EmptyPanel = ({ artData }: { artData: ArtData | undefined }): ReactElement => {
    return (
        <div className="panel">
            <Divider />
            <EmptyOverview artData={artData} />
        </div>
    )
}

export default EmptyPanel
